import React from "react";
import ContentEditable from "react-contenteditable";
import { useDispatch } from "react-redux";
import { Rnd } from "react-rnd";
import {
  batchUpdateLayer,
  selectLayer,
} from "../../features/counter/counterSlice";

function TextComponent({ layer }) {
  const [text, setText] = React.useState("");

  React.useEffect(() => {
    setText(layer.text);
  }, [layer.text]);

  const handleChange = (e) => {
    setText(e.target.value);
  };
  const handleDragStop = (e, { x, y }) => {
    dispatch(
      batchUpdateLayer({
        x,
        y,
      })
    );
  };
  const dispatch = useDispatch();

  const setSelected = () => {
    dispatch(selectLayer(layer));
  };
  return (
    <Rnd
      default={{ x: layer.x, y: layer.y }}
      className="draggable-layer"
      onDragStop={handleDragStop}
      onMouseDown={setSelected}
      size={{ height: "auto" }}
    >
      <ContentEditable
        html={text}
        disabled={true}
        style={{
          fontFamily: layer.ff,
          fontSize: layer.fs,
          color: layer.c,
          outline: "none",
          display: "inline-block",
          width: "auto",
          overflow: "hidden",
          overflowWrap: "break-word",
          whiteSpace: "pre-wrap",
          wordWrap: "break-word",
          wordBreak: "normal",
        }}
        onChange={handleChange} // handle innerHTML change
        tagName="div" // Use a custom HTML tag (uses a div by default)
      />
    </Rnd>
  );
}

export default TextComponent;
